import apiRequest from './apiRequest';

export default async function deleteServiceAccount(
  organizationID: string,
  serviceID: string,
) {
  return await apiRequest<Record<string, never>>(
    'user',
    `/organizations/${encodeURIComponent(organizationID)}/serviceAccounts/${encodeURIComponent(serviceID)}`,
    {
      method: 'DELETE',
    },
  );
}
